export default __webpack_public_path__ + "7d5fef110e8be7933cc0e028f378a2d2.png";